angular.module("gestioneVerbale.components", []).component("gestioneVerbale", {
  templateUrl: "ng/components/gestioneVerbale/gestioneVerbale.html",
  bindings: { richiestePostVendita: "<" },
  controllerAs: "gestioneVerbaleCtrl",
  controller: function gestioneVerbale(
    $RichiestePostVenditaService,
    $rootScope,
    $arcService,
    $location,
    $modalService
  ) {
    var self = this;

    self.$onInit = function () {
      self.supportModel = {
        nextStep: false,
        showMapInfo: false,
        mapInfo: "",
        firmaAlbaLeasing: {
          selected: false,
        },
        signerSelected: null,
        descrizioneBene: {
          selected: true,
        },
        allGoodsSelected: {
          selected: false,
        },
      };
      self.startDate = moment().subtract(30, "d").format("DD/MM/YYYY");
      self.gestioneVerbale = self.richiestePostVendita.metadata.gestioneVerbale;
      self.viewIndex =
        self.getWizardMap(self.richiestePostVendita.viewIndex) == "VRB1"
          ? "VRB1"
          : "VRB2";

      if (self.viewIndex == "VRB1") {
        retrieveStepInfo();
      } else if (self.viewIndex == "VRB2") {
        getStepInfoDetails();
        populateCheckList();
      }
      self.supportModel.firmaAlbaLeasing.selected =
        !self.gestioneVerbale.firmaDigitaleEsterna &&
        self.gestioneVerbale.firmaDigitale
          ? true
          : false;
      self.gestioneVerbale.signers.some(function (signer) {
        if (signer.selected) {
          self.signerSelected = signer;
        }
      });
      self.showFirmatario = self.supportModel.firmaAlbaLeasing.selected
        ? true
        : false;

        // force spit to NO
        self.handleChange('spidSigner', false);
    };

    var retrieveStepInfo = function () {
      self.clearLabelInfo = true;
      $RichiestePostVenditaService
        .getStepInfo(
          self.richiestePostVendita.id,
          self.richiestePostVendita.viewIndex
        )
        .then(function (response) {
          if (response.success) {
            self.supportModel.showMapInfo = response.showBeMessage;
            self.supportModel.mapInfo = response.message;
            self.enabledLoader = false;
          }
          self.clearLabelInfo = false;
        })
        .catch(function (error) {
          console.log(error);
          self.enabledLoader = false;
          self.clearLabelInfo = false;
        });
    };

    self.handleChange = function (prop, value) {
      switch (prop) {
        case "firmaDigitale":
          self.gestioneVerbale.firmaDigitale = value;
          if (!value) {
            self.gestioneVerbale.firmaDigitaleEsterna = false;
            self.supportModel.firmaAlbaLeasing.selected = true;
            self.gestioneVerbale.emailSigner = null;
            self.gestioneVerbale.telSigner = null;
            self.gestioneVerbale.spidSigner = false;
            self.showFirmatario = false;
          } else if (value == true) {
            self.gestioneVerbale.firmaDigitaleEsterna = true;
            self.supportModel.firmaAlbaLeasing.selected = false;
          }
          break;
        case "signer":
          self.signerSelected = value;
          self.gestioneVerbale.signers.some(function (x) {
            if (value && value.cf == x.cf) {
              x.selected = true;
            } else if (!value) {
              x.selected = false;
            }
          });
          break;
        case "dataConsegna":
          self.gestioneVerbale.dataConsegna = value;
          break;
        case "emailSigner":
          self.gestioneVerbale.emailSigner = value;
          break;
        case "telSigner":
          self.gestioneVerbale.telSigner = value;
          break;
        case "spidSigner":
          self.gestioneVerbale.spidSigner = value;
          break;
      }
      self.digitalSign =
        self.gestioneVerbale.firmaDigitale &&
        self.gestioneVerbale.firmaDigitaleEsterna
          ? true
          : false;
    };

    self.check = function (el) {
      el.selected = !el.selected;
      self.gestioneVerbale.firmaDigitaleEsterna = self.supportModel
        .firmaAlbaLeasing.selected
        ? false
        : true;
      self.showFirmatario = self.supportModel.firmaAlbaLeasing.selected
        ? true
        : false;
      if (!self.supportModel.firmaAlbaLeasing.selected) {
        self.gestioneVerbale.emailSigner = null;
        self.gestioneVerbale.telSigner = null;
        self.gestioneVerbale.spidSigner = false;
      }
      self.handleChange();
    };

    self.getWizardMap = function (viewIndex) {
      if (
        $rootScope.wizardMap.find(function (element) {
          return element.index == viewIndex;
        })
      ) {
        return $rootScope.wizardMap.find(function (element) {
          return element.index == viewIndex;
        }).viewName;
      }
    };

    self.nextValidity = function () {
      var test;
      if (self.viewIndex == "VRB1") {
        if (self.gestioneVerbale.firmaDigitale) {
          if (!self.gestioneVerbale.firmaDigitaleEsterna) {
            test =
              self.signerSelected &&
              self.gestioneVerbale.emailSigner &&
              self.gestioneVerbale.telSigner &&
              self.gestioneVerbale.dataConsegna &&
              !self.enabledLoader;
          } else {
            test =
              self.signerSelected &&
              self.gestioneVerbale.dataConsegna &&
              !self.enabledLoader;
          }
        } else {
          test = self.gestioneVerbale.dataConsegna && !self.enabledLoader;
        }
      } else if (self.viewIndex == "VRB2") {
        test = !self.visibleUploadChecklist
          ? !self.enabledLoader
          : self.validityComponent && !self.enabledLoader;
      }
      return test;
    };

    self.next = function () {
      self.enabledLoader = true;
      self.richiestePostVendita.metadata.gestioneVerbale = self.gestioneVerbale;
      if (self.viewIndex == "VRB1") {
        $RichiestePostVenditaService
          .generateAllegatiPv(self.richiestePostVendita)
          .then(function (response) {
            if (response.success) {
              nextStepPv();
            } else {
              self.enabledLoader = false;
            }
          })
          .catch(function (error) {
            console.log(error);
            self.enabledLoader = false;
          });
      } else if (self.viewIndex == "VRB2") {
        $RichiestePostVenditaService
          .saveVerbale(
            self.richiestePostVendita.metadata.gestioneVerbale,
            self.richiestePostVendita.id,
            self.richiestePostVendita.viewIndex,
            self.richiestePostVendita.applicationName,
            self.richiestePostVendita.typeWf
          )
          .then(function (response) {
            if (response.success) {
              $rootScope.$broadcast("addAlert", {
                text: "GEST_VERBALE_OK",
              });
              $location.path("/");
            }
            self.enabledLoader = false;
          })
          .catch(function (error) {
            console.log(error);
            self.enabledLoader = false;
          });
      }
    };

    self.back = function () {
      self.enabledBackLoader = true;
      $RichiestePostVenditaService
        .backStepPv(
          self.richiestePostVendita,
          self.richiestePostVendita.typeWf,
          self.richiestePostVendita.applicationName,
          true
        )
        .then(function (response) {
          self.richiestePostVendita = response;
          self.enabledBackLoader = false;
          if (
            self.getWizardMap(self.richiestePostVendita.viewIndex) == "VRB1"
          ) {
            self.viewIndex = "VRB1";
            retrieveStepInfo();
            self.handleChange()
          }
        })
        .catch(function (error) {
          console.log(error);
          self.enabledBackLoader = false;
        });
    };

    var nextStepPv = function () {
      self.enabledLoader = true;
      self.richiestePostVendita.typeWf = self.richiestePostVendita.typeWf
        ? self.richiestePostVendita.typeWf
        : "WF_POSTVENDITA";
      $RichiestePostVenditaService
        .nextStepPv(
          self.richiestePostVendita,
          self.richiestePostVendita.typeWf,
          self.richiestePostVendita.applicationName,
          true
        )
        .then(function (response) {
          self.richiestePostVendita = response;
          if (
            self.getWizardMap(self.richiestePostVendita.viewIndex) == "VRB2"
          ) {
            self.viewIndex = "VRB2";
            getStepInfoDetails();
            populateCheckList();
          }
          self.enabledLoader = false;
        })
        .catch(function (error) {
          console.log(error);
          self.enabledLoader = false;
        });
    };

    self.validatePage = function (validity) {
      self.validityComponent = validity;
    };

    self.validateUpload = function (validity) {
      self.validityComponent = validity;
      self.nextValidity();
    };

    self.allegatiChange = function (value) {
      if (
        self.richiestePostVendita.metadata.gestioneVerbale.allegati &&
        self.richiestePostVendita.metadata.gestioneVerbale.allegati.length > 0
      ) {
        self.richiestePostVendita.metadata.gestioneVerbale.allegati.push(value);
      } else if (self.richiestePostVendita.metadata.gestioneVerbale.allegati) {
        self.richiestePostVendita.metadata.gestioneVerbale.allegati[0] = value;
      }
    };

    var getStepInfoDetails = function () {
      $arcService
        .getStepInfoDetails(self.richiestePostVendita)
        .then(function (response) {
          self.stepInfoDetailsResponse = response;
        })
        .catch(function (error) {
          console.error(error);
        });
    };

    var populateCheckList = function () {
      self.restUploadRunning = true;
      $arcService
        .checklistPv(self.richiestePostVendita)
        .then(function (response) {
          self.listOfDocumentUpload = response.listDocuments;
          self.visibleUploadChecklist = response.visible;
          self.messageUpload = response.messageUpload;
          self.messageDownload = response.messageDownload;
          self.restUploadRunning = false;
        })
        .catch(function (error) {
          console.error(error);
          self.restUploadRunning = false;
        });
    };

    self.sospendi = function () {
      self.richiestePostVendita.metadata.gestioneVerbale = self.gestioneVerbale;
      self.richiestePostVendita.typeWf = self.richiestePostVendita.typeWf
        ? self.richiestePostVendita.typeWf
        : "WF_POSTVENDITA";
      self.suspendLoader = true;
      $RichiestePostVenditaService
        .suspendInstance(
          self.richiestePostVendita,
          self.richiestePostVendita.typeWf,
          self.richiestePostVendita.applicationName,
          true
        )
        .then(function () {
          self.closeModal()
          $location.path("/");
          self.suspendLoader = false;
        })
        .catch(function (err) {
          console.log(err);
          self.suspendLoader = false;
        });
    };

    self.closeModal = function () {
      $modalService.closeModal("suspendInstance");
    };
  },
});
